// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__v9FKw","wrap":"header_wrap__21s-j","title":"header_title__1DXxp","back":"header_back__Gy6on","content":"header_content__2x66L"};